import ConsoleApi from "@/consoleapi/consoleApi";
import {AxiosResponse} from "axios";

/**
 *
 */
export default class RestcommProfiles extends ConsoleApi {
    protected resource = '/restcomm/profile';

    /**
     * @param accountId
     */
    public find(accountId: string): Promise<AxiosResponse> {
        return this.axios.get(this.requestUri + this.getAccountResource(accountId), {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    /**
     * @param accountId
     * @param Name
     * @param Email
     * @param Password
     */
    public update(accountId: string, Name: string | null, Email: string | null, Password: string | null): Promise<AxiosResponse> {
        return this.axios.put(this.requestUri + this.getAccountResource(accountId), {
            'FriendlyName': Name,
            'EmailAddress': Email,
            'Password': Password,
        }, {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }
}